import { loginByUsername, logout } from '@/api/login'
import { getStore, setStore } from '@/util/store'

const user = {
  state: {
    accountType: undefined,
    access_token: getStore({ name: 'access_token' }) || '',
    avatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif'
  },
  mutations: {
    SET_ACCESS_TOKEN: (state, accessToken) => {
      state.access_token = accessToken
      setStore({
        name: 'access_token',
        content: state.access_token
      })
    }
  },
  actions: {
    loginByUserName({ commit }, user) {
      return loginByUsername(user).then(res => {
        if (res.code === 200) {
          localStorage.setItem("userName", res.data.userName)
          localStorage.setItem("accountType", res.data.accountType)
          commit('SET_ACCESS_TOKEN', res.data.token)
        }
      })
    },

    // 登出
    LogOut({ commit }) {
      return new Promise((resolve, reject) => {
        logout().then(() => {
          commit('SET_ACCESS_TOKEN', '')
          commit('permission/SET_ROUTES', [])
          resolve()
        }).catch(error => {
          commit('SET_ACCESS_TOKEN', '')
          reject(error)
        })
      })
    }

  }
}

export default user
